import { getMessageIndex } from "./indexManager/MessageIndexManager"
import { getRowIndex } from "./indexManager/RowIndexManager"
import { getCompIndex } from "./indexManager/ComponentIndexManager"
import { DnD_element_type_menu } from "./types"
import { getType } from "./utils"

// Exception types
export const exceptionTypes = [DnD_element_type_menu.ELEMENT.SLIDE_PAGE]
export const exceptionCheck_ADD_COMPONENT = (type) => {
  if (exceptionTypes.find((exType) => exType === type)) {
    console.info('exception type detected !!')
    return true // Exception type !!
  }
  return false
}

/**
 * Split row common logic
 * @param {Object} row Row 정보
 * @param {Number} component_index Target component index
 * @param {String} prefix_type 
 * @param {Stirng} type 
 * @param {Array} componentsForNewRow newRow에 대한 컴포넌트 배열
 */
export const common_splitRowFunc = (row, component_index, prefix_type, type, componentsForNewRow) => {
  const { components } = row
  console.log('component_index :', component_index);
  const first_sliced_components = components.slice(0, component_index)
  const last_sliced_components = components.slice(component_index, components.length)

  const first_splitted_row = first_sliced_components.length > 0 ? { // components.length > 0 check for null reuturn
    ...row,
    components: first_sliced_components
  } : null
  console.log('first_splitted_row :', first_splitted_row);
  const _result = getType(row.attr)
  const _prefix_type = _result.prefix
  const _type = _result.type
  console.log('components.slice(component_index, components.length) :', components.slice(component_index, components.length));
  const row_split_new_row = getRow(prefix_type, type, componentsForNewRow ? componentsForNewRow : null)
  console.log('row_split_new_row :', row_split_new_row);
  let row_split_splitted_row = getRow(_prefix_type, _type, last_sliced_components)
  row_split_splitted_row = row_split_splitted_row ?
    row_split_splitted_row.components.length > 0 ? 
      row_split_splitted_row : null : null
    
  console.log('row_split_splitted_row :', row_split_splitted_row);
  return {
    firstSplittedRow: first_splitted_row,
    newRow: row_split_new_row,
    splittedRow: row_split_splitted_row,
  }
}

/**
 * 드래그 된 컴포넌트를 삭제 한 rows를 리턴합니다.
 * 특정 경우에 사용
 * @param {Array} rows 
 * @param {Number} row_index_dragged 
 * @param {Number} component_index_dragged 
 */
export const removeDraggedComponent  = (rows, row_index_dragged, component_index_dragged) => {
  if (!component_index_dragged && component_index_dragged !== 0) {
    return rows.map((row, i) => {
      if (i === row_index_dragged) {
        return null
      }
      return row
    })
  }
  rows = rows.map((row, i) => {
    let { components } = row
    // Dragged process
    if (row_index_dragged === i) {
      // console.log('row 수정 :', row);
      components = components.filter((component, i) => (i !== component_index_dragged))
    }
    // console.log('{...row, components: components} :', {...row, components: components});
    return components ? components.length <= 0 ? null : {...row, components: components} : null // null 리턴 후 함수처리 하여 요소 삭제
  })
  // rows = removeNullElements(rows) // index 간섭 여부로 후처리로 바꿈
  console.log('removeDraggedComponent return rows :', rows);
  return rows
}

/**
 * 배열을 받아 null, undefined인 요소들을 제외한 배열을 리턴
 * @param {Array} components 
 */
export const removeNullElements = (components) => {
  const { length } = components
  const result = []
  for (let component_index=0 ; component_index < length ; component_index++) {
    if (components[component_index]) {
      result.push(components[component_index])
    }
  }
  return result
}

/**
 * Same message / Same row // result: false, code: 0
 * Same message / Other row // result: true, code: 1
 * Other message / Same row // result: true, code: 2
 * Other message / Other row // result: true, code: 3
 * @param {Object} indexObject // payload 
 * Note : message_index_dragged, message_index_target 을 group slide page 케이스의 경우에는 message_index_target만 0으로 들어옴으로
 * 검사 로직이 꼬일 수 있음 (똑같은 메시지로 처리해야 함)
 */
export const isComeOtherRowMessage = (indexObject) => {
  const { message_index_dragged, row_index_dragged, component_index_dragged } = indexObject // Dragged component (source)
  const { message_index_target, row_index_target, component_index_target } = indexObject // Target index position (target)

  if (message_index_dragged === message_index_target && row_index_dragged === row_index_target) {
    return {result: false, code: 0}
  }
  if (message_index_dragged === message_index_target && row_index_dragged !== row_index_target) {
    return {result: true, code: 1}
  }
  if (message_index_dragged !== message_index_target && row_index_dragged === row_index_target) {
    return {result: true, code: 2}
  }
  if (message_index_dragged !== message_index_target && row_index_dragged !== row_index_target) {
    return {result: true, code: 3}
  }
  return null
}

/**
 * 인덱스에 해당하는 컴포넌트를 찾아 callBack함수를 실행한 후 return값을 저장하여 업데이트 된 messages를 반환합니다.
 * @param {Function} callBack 
 * @param {Array} messages 
 * @param {Number} msg_index 
 * @param {Number} row_index 
 * @param {Number} comp_index 
 */
export const searchComponent = (callBack, messages, msg_index, row_index, comp_index) => {
  console.log('== searchComponent ==')
  console.log('messages :', messages);
  console.log('msg_index :', msg_index);
  console.log('row_index :', row_index);
  console.log('comp_index :', comp_index);
  messages = messages.map((message, i) => {
    let { rows } = message
    if (msg_index === i) {
      rows = rows.map((row, i) => {
        let { components } = row
        if (row_index-1 === i) {
          components = components.map((component, i) => {
            if (comp_index-1 === i) {
              return callBack(component)
            }
            return component
          })
          return {
            ...row,
            components: components
          }
        }
        return row
      })
      return {
        ...message,
        rows: rows
      }
    }
    return message
  })

  return messages
}

export const whichTarget = (message_index, row_index, component_index) => {
  const isBlank = (index) => {
    if (!index && index !== 0) {
      return true
    }
    return false
  }

  // Target: Message
  if (!isBlank(message_index) &&
      isBlank(row_index) && 
      isBlank(component_index)) {
    return "MESSAGE"
  }
  
  // Target: Row
  if (!isBlank(message_index) && 
      !isBlank(row_index) && 
      isBlank(component_index)) {
    return "ROW"
  }
  
  // Target: Component
  if (!isBlank(message_index) && 
      !isBlank(row_index) && 
      !isBlank(component_index)) {
    return "COMPONENT"
  }

  console.error("whichTarget - null return")
  return null
}

/**
 * 메시지 인스턴스를 생성합니다.
 * @param {String} prefix_type 
 * @param {String} type 
 * @param {Array} rows // 해당 값으로 초기화하여 메시지 인스턴스를 생성하고 싶을 때 사용
 * @param {Array} components // 해당 값으로 초기화하여 메시지 인스턴스를 생성하고 싶을 때 사용
 */
export const getMessage = (prefix_type, type, rows=null, components=null) => {
  const common_message = {
    local_id: getMessageIndex(),
  }

  // Row initializing
  if (rows) {
    console.log('getMessage - row initializing')
    return {
      ...common_message,
      rows: rows,
    }
  }

  const rows_created = []
  if (prefix_type && type) {
    rows_created.push(getRow(prefix_type, type, components))
  }
  return {
    ...common_message,
    rows: rows_created
  }
}


export const getRow = (prefix_type, type, components=null) => {
  console.log('getRow - prefix_type :', prefix_type);
  console.log('getRow - type :', type);
  const common_row = {
    local_id: getRowIndex(),
    layout: "default"
  }
  switch(prefix_type) {
    case "NORMAL":
      return {
        ...common_row,
        ...getRow_normal(type, components),
      }

    case "SPECIAL":
      return {
        ...common_row,
        ...getRow_special(type, components)
      }

    default:
      console.error("getRow - null return")
      return null
  }
}
export const getRow_normal = (type, components) => {
  switch(type) {
    case "_TEXT":
    case "TEXT":
      return {
        attr: "NORMAL/TEXT",
        components: components ? components : [getComponent("NORMAL", type)]
      }

    case "_BUTTON":
    case "BUTTON":
      return {
        attr: "NORMAL/BUTTON",
        col: 1,
        fillRemainCol: false,
        components: components ? components : [getComponent("NORMAL", type)]
      }

    case "_IMAGE":
    case "IMAGE":
      return {
        attr: "NORMAL/IMAGE",
        col: 1,
        fillRemainCol: false,
        components: components ? components : [getComponent("NORMAL", type)]
      }

    case "_GROUP":
    case "GROUP":
      return {
        attr: "NORMAL/GROUP",
        col: 1,
        fillRemainCol: false,
        components: components ? components : [getComponent("NORMAL", type)]
      }

    default:
      console.error("getRow_normal - null return")
      return null
  }
}

export const getRow_special = (type, components) => {
  switch(type) {
    case "_ADDR":
    case "ADDR":
      return {
        attr: "SPECIAL/ADDR",
        components: components ? components : [getComponent("SPECIAL", type)]
      }

    case "_DATE":
    case "DATE":
      return {
        attr: "SPECIAL/DATE",
        components: components ? components : [getComponent("SPECIAL", type)]
      }

    case "_TEL":
    case "TEL":
      return {
        attr: "SPECIAL/TEL",
        components: components ? components : [getComponent("SPECIAL",  type)] 
      }

    default:
      console.error("getRow_special - null return")
      return null
  }
}

export const getComponent = (prefix_type, type) => {
  type = type && (type.trim())
  switch(prefix_type) {
    case "NORMAL":
      return getComponent_normal(type)

    case "SPECIAL":
      return getComponent_special(type)

    default:
      console.error("getComponent - null return")
      return null
  }
}

export const getComponent_normal = (type) => {
  let resultComponent = {
    local_id: getCompIndex()
  }
  console.log('type :', type);
  console.log('DnD_element_type_menu.COMPONENT.NORMAL.BUTTON :', DnD_element_type_menu.COMPONENT.NORMAL.BUTTON);
  switch(type) {
    case DnD_element_type_menu.COMPONENT.NORMAL.TEXT:
      return {
        ...resultComponent,
        value: ""
      }

    case DnD_element_type_menu.COMPONENT.NORMAL.BUTTON:
      return {
        ...resultComponent,
        name: "",
        value: "",
        redi: false
      }

    case DnD_element_type_menu.COMPONENT.NORMAL.IMAGE:
      return {
        ...resultComponent,
        name: "",
        value: "",
        resource: null
      }

    case DnD_element_type_menu.COMPONENT.NORMAL.GROUP:
    case DnD_element_type_menu.ELEMENT.SLIDE_PAGE:
      return {
        ...resultComponent,
        rows: [],
      }

    default:
      console.error("getComponent_normal - null return type => ", type)
      return null
  }
}

export const getComponent_special = (type) => {
  let resultComponent = {
    local_id: getCompIndex()
  }
  switch(type) {
    case DnD_element_type_menu.COMPONENT.SPECIAL.ADDR:
      return {
        ...resultComponent,
        name: "",
        value: "",
      }

    case DnD_element_type_menu.COMPONENT.SPECIAL.DATE:
      return {
        ...resultComponent,
        name: "",
        value: "",
      }

    case DnD_element_type_menu.COMPONENT.SPECIAL.TEL:
      return {
        ...resultComponent,
        name: "",
        value: "",
      }

    default:
      console.error("getComponent_special - null return type => ", type)
      return null
  }
}